import { getFarmContractName } from 'helpers/mvx/formatters';
import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store';

export const FarmAddressesCard = ({
  onSelectAddress
}: {
  onSelectAddress: (address: string) => void;
}) => {
  const rawVestaConfig = useSelector(
    (state: RootState) => state.rawVesta.config
  );

  return (
    <div className='card'>
      <div className='card-header'>Farm Addresses</div>
      <div className='card-body'>
        {rawVestaConfig.data?.farmAddresses !== undefined &&
          rawVestaConfig.data?.farmAddresses.map((address, i) => (
            <div
              className='border-bottom'
              key={`raw-vesta-cfg-addresses-${i}`}
              onClick={() => onSelectAddress(address)}
              role='button'
            >
              {getFarmContractName(address)}: {address}
            </div>
          ))}
      </div>
    </div>
  );
};
